import { render } from "./ssetf.vue?vue&type=template&id=cb7d0896&scoped=true&ts=true"
import script from "./ssetf.vue?vue&type=script&lang=ts"
export * from "./ssetf.vue?vue&type=script&lang=ts"

import "./ssetf.vue?vue&type=style&index=0&id=cb7d0896&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7d0896"]])

export default __exports__